import { RefObject, useEffect, useRef } from 'react'

/**
 * Fokus-Verwaltung für Overlays: beim Öffnen merkt sich der Hook das aktive Element und fokussiert
 * (optional) `focusSelector` im Container; beim Schließen geht der Fokus zurück.
 */
export function useFocusReturn(open: boolean, container: RefObject<HTMLElement>, focusSelector?: string) {
  const last = useRef<HTMLElement | null>(null)
  const was = useRef(false)
  useEffect(() => {
    if (open && !was.current) {
      last.current = document.activeElement as HTMLElement | null
      const target = focusSelector ? container.current?.querySelector<HTMLElement>(focusSelector) : null
      // nach dem Sichtbarwerden fokussieren
      requestAnimationFrame(() => target?.focus({ preventScroll: true }))
    } else if (!open && was.current) {
      const el = last.current
      last.current = null
      if (el && document.contains(el)) el.focus({ preventScroll: true })
    }
    was.current = open
  }, [open, container, focusSelector])
}

/** Setzt/entfernt das inert-Attribut (React 18 kennt es nicht als Prop). */
export function useInert(ref: RefObject<HTMLElement>, inert: boolean) {
  useEffect(() => {
    const el = ref.current
    if (!el) return
    if (inert) el.setAttribute('inert', '')
    else el.removeAttribute('inert')
  }, [ref, inert])
}
